import React, { useState } from 'react'
import { supabase } from '../supabase'
import './ConstructionRecordForm.css' // 重用相同的樣式

const RegisterForm = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    fullName: '',
    organization: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      // 驗證密碼
      if (formData.password !== formData.confirmPassword) {
        setError('密碼確認不符')
        setLoading(false)
        return
      }

      if (formData.password.length < 6) {
        setError('密碼至少需要6個字符')
        setLoading(false)
        return
      }

      if (!supabase) {
        throw new Error('Supabase 客戶端未正確初始化')
      }

      // 使用 Supabase Auth 進行註冊
      const { data, error } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          data: {
            full_name: formData.fullName,
            organization: formData.organization
          }
        }
      })

      if (error) {
        throw error
      }

      // 創建用戶權限記錄
      if (data.user) {
        try {
          const { error: profileError } = await supabase
            .from('user_permissions')
            .upsert([
              {
                user_id: data.user.id,
                email: formData.email.toLowerCase(), // 確保郵箱統一為小寫
                full_name: formData.fullName,
                organization: formData.organization,
                role: 'pending', // 預設為待審核
                is_active: false,
                created_at: new Date().toISOString()
              }
            ], {
              onConflict: 'email', // 指定以 email 作為衝突檢測欄位
              ignoreDuplicates: false // 不忽略重複，而是更新
            })

          if (profileError) {
            console.warn('創建用戶權限記錄失敗:', profileError)
          }
        } catch (profileError) {
          console.warn('創建用戶權限記錄時發生錯誤:', profileError)
        }
      }
      
      // 清空表單
      setFormData({
        email: '',
        password: '',
        confirmPassword: '',
        fullName: '',
        organization: ''
      })

      // 成功回調
      if (onSuccess) {
        onSuccess(data.user)
      }

      alert('註冊成功！請等待管理員審核您的帳號權限。')
      onClose()

    } catch (error) {
      console.error('註冊失敗:', error)
      
      // 根據錯誤類型提供友善的錯誤訊息
      if (error.message.includes('User already registered')) {
        setError('此郵箱已被註冊')
      } else if (error.message.includes('Password should be at least')) {
        setError('密碼強度不足')
      } else if (error.message.includes('Invalid email')) {
        setError('郵箱格式不正確')
      } else {
        setError('註冊失敗：' + (error.message || '未知錯誤'))
      }
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <h2>用戶註冊</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="construction-form">
          {error && <div className="error-message">{error}</div>}

          <div className="form-section">
            <p style={{ color: '#6c757d', marginBottom: '20px', textAlign: 'center' }}>
              註冊後需要等待管理員審核才能獲得編輯權限
            </p>
            
            <div className="form-group">
              <label>郵箱 *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="請輸入郵箱地址"
              />
            </div>
            
            <div className="form-group">
              <label>姓名 *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                placeholder="請輸入您的姓名"
              />
            </div>
            
            <div className="form-group">
              <label>機構/單位</label>
              <input
                type="text"
                name="organization"
                value={formData.organization}
                onChange={handleChange}
                placeholder="請輸入您的機構或單位"
              />
            </div>
            
            <div className="form-group">
              <label>密碼 *</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="請輸入密碼（至少6個字符）"
                minLength={6}
              />
            </div>
            
            <div className="form-group">
              <label>確認密碼 *</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                required
                placeholder="請再次輸入密碼"
                minLength={6}
              />
            </div>
            
            <div style={{ fontSize: '12px', color: '#6c757d', marginTop: '10px' }}>
              註冊後，您可以查看所有水井資料，但需要管理員審核後才能進行編輯操作
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? '註冊中...' : '註冊'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default RegisterForm 